<template>
  <div class="fob-compact-award-prize">
    <span>
      <span v-if="type">{{type}}:</span>
      <span class="fob-compact-award-prize-label">{{title}}</span>
    </span>

    <div class="fob-compact-award-prize-awardee">
      <span>{{awardee}}</span>
      <span>({{organizationalUnit}})</span>
    </div>
    <div v-if="year && !awardedBy">
      <span><translate>Preis.compact.verliehenIn</translate></span>
      <span>{{year}}.</span>
    </div>
    <div v-else-if="year && awardedBy">
      <span><translate>Preis.compact.verliehenIn</translate></span>
      <span>{{year}}</span>
      <span><translate>Preis.compact.vergebenDurch</translate></span>
      <span>{{awardedBy}}.</span>
    </div>
  </div>
</template>

<script>
import CompactViewHelper from '@/components/mixins/CompactViewHelper'

export default {
  name: 'fob-auszeichnung-compact',
  mixins: [CompactViewHelper],
  props: ['schema', 'data'],
  computed: {
    title () {
      return this.data.namePreis
    },
    awardee () {
      return this.fullName(this.data.preisTraeger)
    },
    awardedBy () {
      return this.data.vergebenDurch
    },
    organizationalUnit () {
      return this.data.organisationseinheit.name
    },
    type () {
      return `${this.data.preisBezeichnung.name.charAt(0).toUpperCase()}${this.data.preisBezeichnung.name.slice(1)}`
    },
    year () {
      return this.data.verleihungsJahr
    }
  }
}
</script>

<style>
  .fob-compact-award-prize-label {
    font-weight: bold;
  }
</style>



// WEBPACK FOOTER //
// src/components/compact/Preis.vue